export const searchMealType: any = {
  allMeals: "All meals",
  breakfastAndDinner: "Breakfast and dinner",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  nothing: "Nothing",
};
